import React from 'react'
import { 
  Box, 
  Container, 
  Typography, 
  Stack,
  IconButton
} from '@mui/material'
import { 
  Mail as MailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon,
  LinkedIn as LinkedInIcon,
  Twitter as TwitterIcon,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon
} from '@mui/icons-material'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'var(--bg-card)',
        borderTop: '1px solid',
        borderColor: 'var(--border-primary)',
        mt: 'auto',
        py: 2
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'start', md: 'center' },
            gap: 2,
            py: 2
          }}
        >
          {/* Copyright */}
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'var(--text-secondary)'
            }}
          >
            © {currentYear} Lognex Insights. Todos os direitos reservados.
          </Typography>

          {/* Informações de Contato */}
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, md: 3 }}
            alignItems={{ xs: 'start', md: 'center' }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <MailIcon sx={{ fontSize: 14, mr: 1, color: 'var(--text-secondary)' }} />
              <Typography 
                variant="body2" 
                sx={{ color: 'var(--text-secondary)' }}
              >
                suporte@lognex.com.br
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <PhoneIcon sx={{ fontSize: 14, mr: 1, color: 'var(--text-secondary)' }} />
              <Typography 
                variant="body2" 
                sx={{ color: 'var(--text-secondary)' }}
              >
                +55 (11) 9999-9999
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <LocationOnIcon sx={{ fontSize: 14, mr: 1, color: 'var(--text-secondary)' }} />
              <Typography 
                variant="body2" 
                sx={{ color: 'var(--text-secondary)' }}
              >
                São Paulo, SP - Brasil
              </Typography>
            </Box>
            
            {/* Social Media Icons */}
            <Stack direction="row" spacing={1} sx={{ ml: { xs: 0, md: 2 } }}>
              <IconButton 
                size="small" 
                component="a"
                href="https://linkedin.com/company/lognex"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  color: 'var(--text-secondary)',
                  '&:hover': {
                    color: 'var(--text-primary)',
                    backgroundColor: 'var(--bg-card-hover)'
                  }
                }}
                title="LinkedIn"
              >
                <LinkedInIcon fontSize="small" />
              </IconButton>
              <IconButton 
                size="small" 
                component="a"
                href="https://twitter.com/lognex"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  color: 'var(--text-secondary)',
                  '&:hover': {
                    color: 'var(--text-primary)',
                    backgroundColor: 'var(--bg-card-hover)'
                  }
                }}
                title="Twitter"
              >
                <TwitterIcon fontSize="small" />
              </IconButton>
              <IconButton 
                size="small" 
                component="a"
                href="https://facebook.com/lognex"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  color: 'var(--text-secondary)',
                  '&:hover': {
                    color: 'var(--text-primary)',
                    backgroundColor: 'var(--bg-card-hover)'
                  }
                }}
                title="Facebook"
              >
                <FacebookIcon fontSize="small" />
              </IconButton>
              <IconButton 
                size="small" 
                component="a"
                href="https://instagram.com/lognex"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  color: 'var(--text-secondary)',
                  '&:hover': {
                    color: 'var(--text-primary)',
                    backgroundColor: 'var(--bg-card-hover)'
                  }
                }}
                title="Instagram"
              >
                <InstagramIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
